
import { Options, Vue } from "vue-class-component";
import address, { filePath } from "@/variable";
import axios from "axios";
import { useStore } from "vuex";

@Options({
  components: {},
})
export default class Form extends Vue {
  doc: any = {};
  suppliers: Array<any> = [];
  store = useStore();
  filePath = filePath;
  mounted() {
    if (this.$route.params.id != undefined) this.fetchData();
    axios
      .post(`${address}/subcontractors-paginate`, {
        search: { type: "Supplier" },
        limit: 9999,
        page: 1,
      })
      .then((response) => {
        console.log(response);
        this.suppliers = response.data.docs;
      });
  }
  fetchData() {
    axios.get(`${address}/tool/${this.$route.params.id}`).then((response) => {
      this.doc = response.data;
    });
  }
  submitForm() {
    if (this.$route.params.id != undefined) {
      axios
        .patch(`${address}/tool/${this.doc._id}`, this.doc)
        .then((response) => {
          alert("แก้ไขข้อมูลแล้ว");
          this.$router.push("/tool");
        });
    } else {
      axios
        .post(`${address}/tool`, {
          ...this.doc,
        })
        .then((response) => {
          alert("บันทึกข้อมูลแล้ว");
          this.$router.push("/tool");
        });
    }
  }
}
